import { defineStore } from "pinia";
import { ref } from "vue";

export const useApplicationStore = defineStore('applicationStore', () => {
    const isTestMode = ref(false);

    return { isTestMode }
});